import { Platform } from 'react-native';
import type { PlanEntitlementsRow } from '../feature-flags/domain/planEntitlements';
import type { GlobalFeatureFlagsMap } from '../feature-flags/domain/globalFeatureFlags';
import type { BranchAccess } from './store/useSessionStore';

const CHANNEL_NAME = 'vuelto-session-cache-v1';

type SessionCacheBroadcast =
  | { type: 'entitlements'; payload: PlanEntitlementsRow | null }
  | { type: 'feature_flags'; payload: GlobalFeatureFlagsMap | null }
  | { type: 'branches'; payload: BranchAccess[] };

let channel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel | null {
  if (Platform.OS !== 'web' || typeof BroadcastChannel === 'undefined') return null;
  channel ??= new BroadcastChannel(CHANNEL_NAME);
  return channel;
}

export function broadcastSessionCache(message: SessionCacheBroadcast): void {
  getChannel()?.postMessage(message);
}

export function subscribeSessionCacheBroadcast(
  handler: (message: SessionCacheBroadcast) => void
): () => void {
  const ch = getChannel();
  if (!ch) return () => {};

  const listener = (event: MessageEvent<SessionCacheBroadcast>) => {
    if (event.data?.type) handler(event.data);
  };
  ch.addEventListener('message', listener);
  return () => ch.removeEventListener('message', listener);
}
